module.exports = __webpack_public_path__ + "8ad5947ab0f3236e5b8df6d5a4fccc7b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/closed-book.png
// module id = 3407
// module chunks = 0